import React, { useEffect, useState } from "react";
import PublicacionCard from "./PublicacionCard";
import './PublicacionesList.css';
import { GetAllPublicidad } from "../../Backend/ApiCalls";


export default function PublicacionesList({ isAdmin, onEdit, linkedPublicationId }) {
  const [publicaciones, setPublicaciones] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [highlightedId, setHighlightedId] = useState(null);

useEffect(() => {
  async function fetchData() {
    const { response, data } = await GetAllPublicidad();
    if (response.ok && Array.isArray(data)) setPublicaciones(data);
    setLoaded(true);
  }
  fetchData();
}, []);

useEffect(() => {
  if (!loaded || !linkedPublicationId) return undefined;
  const linked = publicaciones.find((publication) => String(publication.id) === String(linkedPublicationId));
  if (!linked) return undefined;

  setHighlightedId(String(linked.id));
  const frame = window.requestAnimationFrame(() => {
    document.getElementById(`publication-${linked.id}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
  const timer = window.setTimeout(() => setHighlightedId(null), 3000);
  return () => {
    window.cancelAnimationFrame(frame);
    window.clearTimeout(timer);
  };
}, [linkedPublicationId, loaded, publicaciones]);

  const linkedPublicationMissing = loaded && linkedPublicationId
    && !publicaciones.some((publication) => String(publication.id) === String(linkedPublicationId));


  const handleDelete = (id) => {
    setPublicaciones((items) => items.filter((publication) => publication.id !== id));
  };

  return (
    <div className="publicaciones-list">
      {linkedPublicationMissing && (
        <p className="linked-publication-unavailable" role="status">
          Esta publicación ya no está disponible.
        </p>
      )}
      {publicaciones.map(pub => (
        <PublicacionCard
          key={pub.id}
          item={pub}
          isAdmin={isAdmin}
          onEdit={onEdit}
          onDelete={handleDelete}
          highlighted={String(pub.id) === highlightedId}
        />
      ))}
    </div>
  );
}
